/** Alat peletakan lukisan (pelan P4-4b): suis Tetapan dan panelnya. Placeholder sama dengan placement-en.ts. */
export default {
  settings: {
    title: 'Alat peletakan lukisan',
    enabled: 'Tawarkan alat peletakan lukisan',
    hint: 'Dimatikan secara lalai. Apabila dihidupkan, panel piawaian lukisan menawarkan alat yang memindahkan DXF ke koordinat sebenarnya berdasarkan dua titik yang ditaip, dalam pelayar. Semakan itu sendiri tidak berubah.',
    warning:
      'Sama ada alat ini boleh diterima, atau sama ada koordinat mesti datang daripada lukisan juruukur berlesen sahaja, belum disahkan. Fail yang diletakkan tidak membawa sebarang tanda, jadi mematikan alat ini kemudian tidak dapat mengenal pasti lukisan yang telah diletakkan.',
    noBoundary:
      'Tiada sempadan bidang kuasa ditetapkan, jadi alat ini tidak akan ditawarkan kepada pemohon: tanpa sempadan, tiada apa yang menyemak di mana lukisan yang diletakkan itu berada.',
  },
  open: 'Letakkan lukisan saya pada koordinat sebenarnya',
  hint: 'Untuk lukisan yang dibuat pada koordinat tempatan. Fail anda kekal dalam pelayar ini sehingga anda menyerahkannya.',
  note: 'Taip koordinat daripada pelan ukur yang diperakui. Alat ini tidak memperakuinya, dan semakan penuh tetap dijalankan pada apa yang anda serahkan.',
  close: 'Tutup alat peletakan',
  fileLabel: 'Fail DXF',
  reading: 'Membaca lukisan…',
  unitLabel: 'Unit lukisan ini',
  unitChoose: 'Pilih unit',
  units: { m: 'Meter', mm: 'Milimeter', cm: 'Sentimeter', ft: 'Kaki' },
  crsFirst: 'Pilih sistem koordinat dahulu.',
  points: { a: 'Titik A', b: 'Titik B', check: 'Titik semakan' },
  vertexLabel: 'Titik dalam lukisan',
  vertexChoose: 'Pilih titik',
  listCut: 'Hanya {{count}} titik pertama disenaraikan.',
  verticesCut:
    'Lukisan ini mempunyai terlalu banyak titik untuk disenaraikan. Setiap lapisan menyenaraikan {{limit}} titik pertamanya sahaja.',
  east: 'Timur, {{crs}}',
  north: 'Utara, {{crs}}',
  checkHint:
    'Titik ketiga, tidak digunakan untuk meletakkan lukisan. Ia wajib kerana dua titik sahaja tidak dapat menentukan sama ada lukisan itu tercermin atau titik-titiknya tertukar.',
  drawingTitle: 'Lukisan anda',
  placedTitle: 'Lukisan yang diletakkan, utara di atas',
  compute: 'Kira peletakan',
  result:
    'Skala: 1 unit lukisan = {{factor}} m. Putaran: {{rotation}} darjah. Titik A berada {{a}} mm dari koordinatnya, titik B {{b}} mm.',
  resultCheck: 'Titik semakan berada {{off}} mm dari koordinatnya.',
  resultCrs:
    'Koordinat ini dalam {{crs}}. Isytiharkan sistem koordinat yang sama apabila anda menyerahkan lukisan ini.',
  download: 'Muat turun DXF yang diletakkan',
  downloadHint:
    'Buka dalam perisian CAD anda dan gunakan Zoom Extents, kerana paparan tersimpannya masih menghala ke tempat lama. Semak dengan pelan yang diperakui, kemudian pilih sebagai lukisan anda. Lapisan, takrifan blok dan teks tidak berubah.',
  file: {
    dwg_file: 'Ini fail DWG. Simpan sebagai DXF dalam perisian CAD anda, kemudian muatkan di sini.',
    binary_dxf: 'Ini DXF binari. Simpan sebagai DXF ASCII dalam perisian CAD anda, kemudian muatkan di sini.',
    not_dxf: 'Fail ini bukan DXF.',
    truncated: 'DXF ini tiada penanda akhir, jadi mungkin tidak lengkap. Simpan semula dan muatkan sekali lagi.',
    malformed: 'DXF ini tidak dapat dibaca pada baris {{line}}.',
    no_entities: 'DXF ini tiada entiti lukisan.',
    too_large: 'Fail ini melebihi {{limit}} MB, had muat naik terbesar di sini.',
    output_too_large:
      'Fail yang diletakkan akan menjadi {{size}} MB, melebihi had muat naik {{limit}} MB. Buang apa yang tidak diperlukan oleh lukisan dan cuba lagi.',
  },
  refusedTitle: 'Alat ini tidak dapat memindahkan lukisan kerana kandungannya:',
  refusedRow: '{{type}} pada lapisan {{layer}}: {{count}} ({{reason}})',
  refusedFix: 'Padam atau letupkan (explode) ini dalam perisian CAD anda, simpan sebagai DXF dan muatkan semula.',
  reason: {
    not_allowed: 'jenis yang tidak dipindahkan oleh alat ini',
    extrusion: 'dilukis tercermin atau pada satah lain',
    embedded_object: 'mengandungi objek terbenam',
    xdata_coordinates: 'membawa koordinat dalam data lanjutannya',
    polyline_mesh: 'jaringan (mesh)',
    polyline_curve_fit: 'polilina dipadankan lengkung',
    spline_fit_points: 'spline yang dilukis melalui titik padanan',
    hatch_spline_edge: 'hatch dengan tepi spline',
    hatch_gradient: 'hatch gradien',
    xref_insert: 'rujukan luaran',
    undefined_block: 'menamakan blok yang tidak ditakrifkan dalam fail',
    mtext_direction: 'teks berbilang baris yang diputar tanpa arah',
    drawing_object: 'keratan atau lokasi tersimpan yang akan menjadi lapuk',
  },
  fit: {
    scale_mismatch:
      'Dalam unit yang dipilih, dua titik lukisan berjarak {{drawing}} m, tetapi koordinat yang ditaip berjarak {{typed}} m: berbeza lebih daripada 0.1 %. Semak unit dan titik-titiknya.',
    degenerate_drawing: 'Titik A dan B ialah titik yang sama. Pilih dua titik berbeza.',
    degenerate_typed: 'Koordinat yang ditaip untuk A dan B adalah sama.',
    bad_number: 'Taip setiap koordinat sebagai nombor biasa dalam meter, seperti 412345.678, tanpa pemisah ribuan.',
    out_of_range:
      'Koordinat yang ditaip terlalu besar bagi mana-mana sistem koordinat yang ditawarkan di sini. Semaknya.',
    baseline_too_short:
      'Titik A dan B terlalu dekat: jarak sekurang-kurangnya {{min}} m diperlukan, atau kesilapan taip yang kecil akan mengalihkan penjuru jauh sebanyak beberapa meter.',
    check_point_missing: 'Titik semakan diperlukan: pilih titik itu dalam lukisan dan taip kedua-dua koordinatnya.',
    mirrored:
      'Titik semakan tidak sepadan: lukisan kelihatan tercermin berbanding koordinat yang ditaip, atau titik atau koordinat tertukar. Semaknya. Jika lukisan tercermin, cerminkan semula dalam perisian CAD anda.',
    check_point_off: 'Titik semakan berada {{off}} m dari koordinat yang ditaip. Semak titik dan koordinatnya.',
    check_point_collinear:
      'Titik semakan hampir berada pada garis melalui A dan B, jadi ia tidak membuktikan apa-apa. Pilih titik yang lebih jauh dari garis itu.',
  },
  preview: {
    open: 'Pratonton pada peta',
    warning:
      'Klik adalah anggaran dan tidak sekali-kali digunakan untuk fail yang dimuat turun, yang mengambil koordinat yang ditaip sahaja.',
    needPoints: 'Pilih titik A dan B dalam lukisan dahulu.',
    clickA: 'Klik di mana titik A berada.',
    clickB: 'Klik di mana titik B berada.',
    placed: 'Lebih kurang di mana lukisan akan berada.',
    clear: 'Kosongkan klik',
    map: 'Pratonton peletakan pada peta',
  },
}
